export const CartCountdownTime = {
	// CART_TIMEOUT: 0.2,
	CART_TIMEOUT: 15,
};

export const InactiveAlertTime = {
	// ALERT_WAIT: 0.1,
	ALERT_WAIT: 5,
};

export const ExtendTime = {
	// EXTEND: 0.2,
	EXTEND: 15,
};

export const FinalCheckoutTime = {
	// CHECKOUT: 0.15,
	CHECKOUT: 10,
};
